import React, { useMemo } from "react";
import { inject, observer } from "mobx-react";
import { Option } from "../../../../common/forms/Interfaces";
import SelectFilter from "../selectFilter";
import { IFilterProps, IFilterWithStoreProps } from "../Interfaces";

const DepartmentFilter: React.FC<IFilterWithStoreProps> = inject("store")(
  observer(
    ({
      setSelectedKeys,
      confirm,
      clearFilters,
      store,
      selectedKeys,
      multiple,
    }) => {
      const settingsStore = store?.settingsStore;
      const options = useMemo(
        (): Option[] =>
          settingsStore?.departments ? settingsStore?.departments : [],
        [settingsStore]
      );

      return (
        <SelectFilter
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
          options={options}
          multiple={multiple}
        />
      );
    }
  )
);

const Wrapper: React.FC<IFilterProps> = ({
  setSelectedKeys,
  confirm,
  clearFilters,
  selectedKeys,
  multiple,
}) => (
  <DepartmentFilter
    selectedKeys={selectedKeys}
    setSelectedKeys={setSelectedKeys}
    confirm={confirm}
    clearFilters={clearFilters}
    multiple={multiple}
  />
);

export default Wrapper;
